//For modern browsers. IE11 uses doSubmit.old.js
import { PIC, PICLoadPage, PICGetAns } from '../templates/Internals';
if (!window.doSubmit)
    window.doSubmit = doSubmit;
if (!window.openChoiceBox)
    window.openChoiceBox = openChoiceBox;
if (!window.fireSubmit)
    window.fireSubmit = fireSubmit;
if (!window.doSubmitOnChange)
    window.doSubmitOnChange = doSubmitOnChange;
if (!window.getShadowInputs)
    window.getShadowInputs = getShadowInputs;
/* move to separate file? ... openBox is on there... but this could be a util function */
export function openChoiceBox(selector, data) {
    let cb;
    if (typeof selector === 'string' || selector instanceof String)
        cb = document.querySelector(selector);
    else
        cb = selector;
    if (!cb)
        return;
    if (data)
        cb.data = data;
    cb.openBox();
}
export function submitEventHandler(iEvent, iEventId, iSubmitData) {
    var _a, _b;
    if (iEvent) {
        let elm;
        let submithandlers = iEvent.composedPath().filter((elm) => { return elm instanceof PICLoadPage; });
        let eventHandler;
        // if element has passed reference, check if it's in a modal
        if (iEvent.type == 'mySuperAwesomeEvent') {
            elm = iEvent.detail.elm;
            if (elm) {
                //web 3 
                if (elm.getRootNode().firstElementChild.nodeName == 'PIC-MODAL') {
                    elm = elm.getRootNode().host;
                }
                else { //web2
                    if ((_b = (_a = elm.getRootNode()) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.dom) {
                        elm = elm.getRootNode().firstElementChild.dom;
                    }
                    else {
                        elm = null;
                    }
                }
                if (elm)
                    submithandlers = [elm];
            }
        }
        // most events
        if (submithandlers.length > 0) {
            // event originates in a modal, let the modal handle it. 
            eventHandler = submithandlers[0];
            eventHandler.handleSubmit(iEventId, iSubmitData);
            return;
            // some events (like focus, have broken composedPaths (most likely caused by domInsertion in PICLoadPage))
        }
        else if (iEvent.composedPath()[iEvent.composedPath().length - 1] instanceof DocumentFragment) {
            if (iEvent.composedPath()[iEvent.composedPath().length - 1].host instanceof PICLoadPage) {
                // event originates in a modal, let the modal handle it.
                eventHandler = iEvent.composedPath()[iEvent.composedPath().length - 1].host;
                eventHandler.handleSubmit(iEventId, iSubmitData);
                return;
            }
        }
        // Do the same runthrough for getans 
        let ans;
        let meDown = iEvent.composedPath().filter(x => x instanceof PICGetAns);
        try {
            if (meDown && meDown.length > 0) {
                ans = meDown[0];
            }
            else if (iEvent.composedPath()[iEvent.composedPath().length - 1] instanceof DocumentFragment) {
                ans = iEvent.composedPath()[iEvent.composedPath().length - 1].host;
            }
            if (ans && ans.parentId && PIC.getInstance.PICWinMap.has(ans.parentId)) {
                if (PIC.getInstance.PICWinMap.get(ans.parentId) instanceof PICLoadPage) {
                    let getAnsElement = document.querySelector('pic-getans#base-ans');
                    getAnsElement.isHidden = true;
                    PIC.getInstance.PICWinMap.get(ans.parentId).handleSubmit(iEventId, iSubmitData);
                    return;
                }
            }
        }
        catch (_c) {
        }
    }
    // event came from light dom, let regular doSubmit handle it.
    doSubmit(iEventId, iSubmitData);
}
export function doSubmit(eventId, submitData) {
    var _a, _b, _c;
    if (submitData) {
        // if force then just submit
        if (submitData.force) {
            fireSubmit(eventId);
            return;
        }
        if (submitData.newTab) {
            //TODO open in new tab command
        }
    }
    let input = document.querySelector('input[name="button_' + eventId + '"],select[onchange*="' + eventId + '"]');
    /* matches 'startswith' doesn't work for spinners etc */
    let hasChoiceBox = ((_a = submitData === null || submitData === void 0 ? void 0 : submitData.choiceBox) === null || _a === void 0 ? void 0 : _a.hasChoiceBox) || (input === null || input === void 0 ? void 0 : input.hasAttribute('choicebox')) || (input === null || input === void 0 ? void 0 : input.hasAttribute('choiceBox-x'));
    let isDefaultBox = (_b = submitData === null || submitData === void 0 ? void 0 : submitData.choiceBox) === null || _b === void 0 ? void 0 : _b.isDefaultBox;
    let overrideDefault = (_c = submitData === null || submitData === void 0 ? void 0 : submitData.choiceBox) === null || _c === void 0 ? void 0 : _c.customBox;
    if (hasChoiceBox) {
        if (isDefaultBox) {
            let defaultChoiceElm = document.querySelector('input[name="__defaultchoice"]');
            let defaultChoiceObj;
            if (defaultChoiceElm && defaultChoiceElm.hasAttribute('choiceTitle')) {
                defaultChoiceObj = { choiceTitle: defaultChoiceElm.getAttribute('choiceTitle'), choices: [{ choiceText: defaultChoiceElm.getAttribute('choicetrue'), choiceEvent: eventId }, { choiceText: defaultChoiceElm.getAttribute('choicefalse'), choiceEvent: '' }], attributes: { hidden_: false } };
            }
            else
                defaultChoiceObj = { choiceTitle: 'Are you sure?', choices: [{ choiceText: 'Yes', choiceEvent: eventId }, { choiceText: 'No', choiceEvent: '' }], attributes: { hidden_: false } };
            openChoiceBox('pic-choicebox[choicebox-x]', defaultChoiceObj);
            return;
        }
        else if (overrideDefault) {
            openChoiceBox('pic-choicebox[choicebox-x]', overrideDefault);
            return;
        }
        else {
            if (!input)
                return;
            let cb = input.nextElementSibling;
            if (cb && cb.nodeName === 'PIC-CHOICEBOX') {
                openChoiceBox(cb, null);
                return;
            }
        }
    }
    /* validation - custom reportValidity()-ish*/
    // let shadowInputs = getShadowInputs()
    // if (true) shadowInputs.forEach(input => document.PICForm.appendChild(input));
    fireSubmit(eventId);
}
function fireSubmit(eventId) {
    if (PIC.getInstance.fromProgress) {
        const eventidInput = document.getElementById('eventid');
        eventidInput.value = eventId;
        window._log('Firing event', eventId, 'documentMode' in document);
        if (PIC.getInstance.ctrlKeyIsDown) {
            window._log('Opening new tab');
            /* If new window allowed then do that */
            let extraInput = document.createElement('input');
            extraInput.setAttribute('type', 'hidden');
            extraInput.setAttribute('id', 'SessionOption');
            extraInput.setAttribute('name', 'SessionOption');
            // extraInput.setAttribute('value', 'new');
            extraInput.setAttribute('value', 'duplicate');
            let form = document.querySelector('#PICForm');
            form === null || form === void 0 ? void 0 : form.appendChild(extraInput);
            PIC.getInstance.openNewWindow = true;
        }
        if ('documentMode' in document) { /* submit event if IE 11 */
            document.PICForm.submit();
        }
        else
            document.PICForm.dispatchEvent(new Event('submit', { cancelable: true }));
    }
    else {
        /* This is when bundle is not used from progress */
        document.dispatchEvent(new Event('submit', { cancelable: true }));
    }
}
/**
 * takes all input elements in shadowroots and appends them to the form for submission
 * DO NOT append for validation, they will be broken afterwards
 */
function getShadowInputs() {
    let shadowInputs = [];
    let nodes = Array.from(document.body.querySelectorAll('*'));
    nodes.filter(node => node.nodeName.startsWith('PIC-') && node.hasAttribute('value'))
        .forEach(node => {
        var _a;
        return (_a = node.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input').forEach(child => shadowInputs.push(child));
    });
    return shadowInputs;
}
/**
 * Calls doSubmit with a string prefix + '_'
 * @param event
 * @param prefix
 */
function doSubmitOnChange(event, prefix) {
    let target = event.target;
    if (!target.value) {
        return false;
    }
    let val = prefix + '_' + target.value.replace(/\\s/g, '');
    doSubmit(val);
}
//# sourceMappingURL=doSubmit.new.js.map